
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuola-dell-infanzia/risorse",
      function () {
        return require("private-next-pages/scuola-dell-infanzia/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuola-dell-infanzia/risorse"])
      });
    }
  